const AUTH_ROUTES = {
  LOGIN: 'auth/login/',
  LOGOUT: (userId) => `auth/logout/${userId}`,
  SIGNUP: 'auth/signup/',
  SEND_RESET_PASSWORD_MAIL: 'auth/sendResetPasswordMail',
  RESET_PASSWORD: 'auth/resetPassword',
  FETCH_SCHOOLS: 'characterdaily/api/school/1',
  FETCH_SCHOOLS_BY_PASSCODE: (passcode) =>
    `characterdaily/api/passcodes/passcodesByValue/${passcode}`,
  FETCH_ROLES: 'characterdaily/api/systemroles',
  FETCH_GRADES: 'characterdaily/api/grades',
  CREATE_GROUP: 'characterdaily/lead/',
  FETCH_PROFILE: 'characterdaily/api/users/user/me',
  UPDATE_PROFILE: 'characterdaily/api/users/',
  FETCH_SLIDER_DATA: 'characterdaily/leadimages/1',
};

const HOME_ROUTES = {
  FETCH_SCHEDULE_DATA: (userId, month, year) =>
    `characterdaily/api/lessonplan/${userId}/getScheduleData/${month}/${year}`,
  INVITE_USER: (email) => `characterdaily/api/users/invite/${email}`,
  SUBMIT_CONTACT_FORM: `characterdaily/feedback/savefeedback`,
  FETCH_MESSAGES: (page) => `characterdaily/api/message/getAllMessages/${page}`,
  FETCH_NOTIFICATIONS: (userId, page) =>
    `notificationservice/api/getAllNotifications/${userId}/${page}`,
  MARK_NOTIFICATION_READ: (notificationId) =>
    `notificationservice/api/markNotificationAsRead/${notificationId}`,
  DELETE_NOTIFICATION: (notificationId) =>
    `notificationservice/api/${notificationId}`,
  FETCH_UNREAD_COUNT: (userId) =>
    `notificationservice/api/getAllUnreadNotificationCountForUser/${userId}`,
  FETCH_COMPLETION: (userId, ids) =>
    `characterdaily/api/lessonplan/${userId}/getCompletionStatus/${ids}`,
};

const LESSON_ROUTES = {
  FETCH_LESSON_DETAILS_DATA: (userId, lessonId) =>
    `characterdaily/api/lessons/lessondetailsforuser/${userId}/${lessonId}`,
  MARK_LESSON_COMPLETE: (userId, lessonId) =>
    `characterdaily/api/lessons/${userId}/marklessonascomplete/${lessonId}`,
  MARK_LESSON_INCOMPLETE: (userId, lessonId) =>
    `characterdaily/api/lessons/${userId}/marklessonasincomplete/${lessonId}`,
  ADD_LESSON_TO_CLASSROOM: (lessonId, classroomId) =>
    `characterdaily/api/classrooms/${lessonId}/addLessonToClassroom/${classroomId}`,
};

const BEHAVIOUR_ROUTES = {
  FETCH_BEHAVIOUR_DETAILS_DATA: (userId, behaviourId) =>
    `characterdaily/api/behaviours/behaviourdetailsforuser/${userId}/${behaviourId}`,
  MARK_BEHAVIOUR_COMPLETE: (userId, behaviourId) =>
    `characterdaily/api/behaviours/${userId}/markbehaviourascomplete/${behaviourId}`,
  MARK_BEHAVIOUR_INCOMPLETE: (userId, behaviourId) =>
    `characterdaily/api/behaviours/${userId}/markbehaviourasincomplete/${behaviourId}`,
  ADD_BEHAVIOUR_TO_CLASSROOM: (behaviourId, classroomId) =>
    `characterdaily/api/classrooms/${behaviourId}/addBehaviourToClassroom/${classroomId}`,
};

const QUOTE_ROUTES = {
  FETCH_QUOTE_DETAILS_DATA: (userId, quoteId) =>
    `characterdaily/api/quotes/quotedetailsforuser/${userId}/${quoteId}`,
  MARK_QUOTE_COMPLETE: (userId, quoteId) =>
    `characterdaily/api/quotes/${userId}/markquoteascomplete/${quoteId}`,
  MARK_QUOTE_INCOMPLETE: (userId, quoteId) =>
    `characterdaily/api/quotes/${userId}/markquoteasincomplete/${quoteId}`,
  ADD_QUOTE_TO_CLASSROOM: (quoteId, classroomId) =>
    `characterdaily/api/classrooms/${quoteId}/addQuoteToClassroom/${classroomId}`,
};

const CLASSROOM_ROUTES = {
  FETCH_CLASSROOMS: (userId, page) =>
    `characterdaily/api/classrooms/${userId}/${page}`,
  CREATE_CLASSROOM: 'characterdaily/api/classrooms/',
  SHARE_CLASSROOM: 'characterdaily/api/classrooms/shareClassroomWithUser',
  ACCEPT_CLASSROOM: 'characterdaily/api/classrooms/addExistingClassroomForUser',
  UPDATE_CLASSROOM: (classroomId) =>
    `characterdaily/api/classrooms/${classroomId}`,
  REMOVE_ENTITY: (classroomId, entityId) =>
    `characterdaily/api/classrooms/${entityId}/removeEntityFromClassroom/${classroomId}`,
  DELETE_CLASSROOM: (classroomId) =>
    `characterdaily/api/classrooms/${classroomId}`,
  FETCH_CLASSROOM_DETAILS: (classroomid) =>
    `characterdaily/api/classrooms/classroomById/${classroomid}`,
};

const FAVORITE_ROUTES = {
  IS_MARKED_FAVORITE: (userId, entityType, entityId) =>
    `characterdailypersonalisation/${userId}/isMarkedFavourite/${entityType}/${entityId}`,
  MARK_FAVORITE: (userId, entityType, entityId) =>
    `characterdailypersonalisation/${userId}/markAsFavourite/${entityType}/${entityId}`,
  REMOVE_FAVORITE: (userId, entityType, entityId) =>
    `characterdailypersonalisation/${userId}/deleteFromFavourites/${entityType}/${entityId}`,
  FETCH_FAVORITES: (userId, page) =>
    `characterdailypersonalisation/${userId}/getAllFavourites/${page}`,
};

const RESOURCE_ROUTES = {
  FETCH_RESOURCES: (userId) =>
    `characterdaily/api/parentresourcesbyschool/${userId}`,
  FETCH_RESOURCE_DETAILS: (resourceId) =>
    `characterdaily/api/resources/${resourceId}`,
  FETCH_SONGS: (page) => `characterdaily/api/songs/${page}`,
};

const SEARCH_ROUTES = {
  SEARCH: 'characterdaily/api/search',
};

const LESSON_SETTINGS_ROUTES = {
  FETCH_PILLAR_METADATA_WITH_SCHEDULE: (userId, month, year) =>
    `characterdaily/api/lessonplan/${userId}/getpillarmetadatawithdefaultscheduledata/${month}/${year}`,
  UPDATE_PILLAR_SCHEDULE: (userId, month, year) =>
    `characterdaily/api/lessonplan/${userId}/getScheduleData/${month}/${year}`,
};

const TOOLS_ROUTES = {
  FETCH_PILLARS: (page) => `characterdaily/api/pillars/pillarsMetadata/${page}`,
  FETCH_TOOLS_CONTENT: (slug) => `characterdaily/api/views/getView/${slug}`,
  FETCH_TOOLS_LIST: `characterdaily/api/views/getAllViewsMetadata`
};

const SUBSCRIPTION_ROUTES = {
  CREATE_CUSTOMER: (userId) =>
    `characterdaily/api/users/createCustomer/${userId}`,
  FETCH_SUBSCRIPTION_TYPES: `subscriptions/api/getAllSubscriptionTypes`,
  CHECKOUT: `subscriptions/checkout`,
  CREATE_SUBSCRIPTION: `subscriptions/createsubscription`,
  FETCH_USER_SUBSCRIPTIONS: (userId) =>
    `characterdaily/createsubscription/${userId}`,
  GET_SUBSCRIPTIONS_FOR_USER: (userId) =>
    `subscriptions/getsubscriptionsforuser/${userId}`,
  CANCEL_SUBSCRIPTIONS_FOR_USER: `subscriptions/cancelsubscription`,
  FETCH_REFERRERS: `characterdaily/referrer/1`,
  SUBMIT_REFERRER: (userId, referrer) =>
    `characterdaily/api/users/setReferrer/${userId}/${referrer}`,
};

const NOTIFICATION_ROUTES = {
  SAVE_TOKEN: 'notificationservice/api/saveTokenForUser',
  DELETE_TOKEN: 'notificationservice/api/deleteTokenForUser',
};

const NOTES_ROUTES = {
  GET_NOTES_BY_ENTITY: (userId, entityId) =>
    `characterdailypersonalisation/api/user/${userId}/note?entityId=${entityId}`,
  CREATE_NOTE_FOR_ENTITY: (userId) =>
    `characterdailypersonalisation/api/user/${userId}/note/`,
  GET_ALL_USER_NOTES: (userId, pageNumber) =>
    `characterdailypersonalisation/api/user/${userId}/notes?pageNumber=${pageNumber}`,
  UPDATE_NOTE_FOR_ENTITY: (userId, noteId) =>
    `characterdailypersonalisation/api/user/${userId}/note/${noteId}`,
  DELETE_USER_NOTES: (userId, noteId) =>
    `characterdailypersonalisation/api/user/${userId}/note/${noteId}`
}

const ENDPOINTS = {
  ...AUTH_ROUTES,
  ...HOME_ROUTES,
  ...LESSON_ROUTES,
  ...BEHAVIOUR_ROUTES,
  ...QUOTE_ROUTES,
  ...CLASSROOM_ROUTES,
  ...FAVORITE_ROUTES,
  ...RESOURCE_ROUTES,
  ...SEARCH_ROUTES,
  ...LESSON_SETTINGS_ROUTES,
  ...TOOLS_ROUTES,
  ...SUBSCRIPTION_ROUTES,
  ...NOTIFICATION_ROUTES,
  ...NOTES_ROUTES
};

export { ENDPOINTS };
